<template>
  <el-row>
    <el-row style="width:70%; margin:0 auto; ">
      <el-row >
        <!-- 标签 --> 
        <el-row >
          <el-menu
            default-active="/MyLoan"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b">
            <el-menu-item index="/MyLoan">生源地贷款</el-menu-item>
            <el-menu-item index="/OfflinePay">线下审核</el-menu-item>
            <el-menu-item index="/Exit">退出</el-menu-item>
          </el-menu>
          <br>
          <br>
        </el-row>
      </el-row>
      <!-- 新生贷款选择 -->
      <el-row v-show="chooseVisible" class="back-up" style="background-color: #fff;">
        <el-row style="text-align:center;margin-top:30px;">
          <el-radio v-model="radio" label="0" border>未办理生源地贷款</el-radio>
          <el-radio v-model="radio" label="1" border>已办理生源地贷款</el-radio>
          <el-row style="margin: 20px auto"><el-button style="width: 50%" type="success" @click="nextLoan()">下一步</el-button></el-row>
        </el-row>
      </el-row>
      <!-- 贷款信息 -->
      <el-row v-show="loanInfoVisible" style="background-color: #fff;text-align: center;">
        <el-row>
          <el-form :inline="global.editInline" :model="loanForm" ref="loanForm" :label-width="formLabelWidth" size="medium" :inline-message='true' 
          style="width: 50%;margin: 20px auto;" :rules="rules">
            <el-form-item label="贷款银行" :class="Ginkgo.getEditItemClass(global.editInline)">
              <el-select v-model="loanForm.bankType" placeholder="== 请选择 ==" >
                <el-option v-for="option in bankTypeList" :key="option.modeId" :label="option.modeName" :value="option.modeId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学生姓名" :class="Ginkgo.getEditItemClass(global.editInline)">
              <span class="label_value">{{ loanForm.studentName }}</span>
            </el-form-item>
            <el-form-item label="身份证" :class="Ginkgo.getEditItemClass(global.editInline)">
              <span class="label_value">{{ loanForm.keyInfo }}</span>
            </el-form-item>
            <el-form-item label="联系电话" key="Mobile" prop="mobile" :class="Ginkgo.getEditItemClass(global.editInline)">
              <el-input v-model="loanForm.mobile" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="贷款金额" key="Loan_Amount" prop="loanAmount" :class="Ginkgo.getEditItemClass(global.editInline)">
              <el-input v-model="loanForm.loanAmount" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="备注" :class="Ginkgo.getEditItemClass(global.editInline)">
              <el-input v-model="loanForm.remark" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="贷款受理证明或回执单">
              <el-upload
                list-type="picture-card"
                :action="uploadAction" :headers="uploadHead" :data="uploadData"
                :before-upload="beforeUploadLoan" :on-success="successUploadLoan" :on-error="errorUploadLoan"
                :accept="'image/*'"
                :on-remove="handleRemoveLoan"
                :before-remove="beforeRemoveLoan"
                :limit="1"
                :on-exceed="handleExceedLoan"
                :on-change="handleUploadChangeLoan"
                :file-list="loanFileList">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="身份证国徽面照片">
              <el-upload
                list-type="picture-card"
                :action="uploadAction" :headers="uploadHead" :data="uploadData"
                :before-upload="beforeUploadUidJust" :on-success="successUploadUidJust" :on-error="errorUploadUidJust"
                :accept="'image/*'"
                :on-remove="handleRemoveUidJust"
                :before-remove="beforeRemoveUidJust"
                :limit="1"
                :on-exceed="handleExceedUidJust"
                :on-change="handleUploadChangeUidJust"
                :file-list="uidJustFileList">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="身份证人像面图片">
              <el-upload
                list-type="picture-card"
                :action="uploadAction" :headers="uploadHead" :data="uploadData"
                :before-upload="beforeUploadUidBack" :on-success="successUploadUidBack" :on-error="errorUploadUidBack"
                :accept="'image/*'"
                :on-remove="handleRemoveUidBack"
                :before-remove="beforeRemoveUidBack"
                :limit="1"
                :on-exceed="handleExceedUidBack"
                :on-change="handleUploadChangeUidBack"
                :file-list="uidBackFileList">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="其他证明图片">
              <el-upload
                list-type="picture-card"
                :action="uploadAction" :headers="uploadHead" :data="uploadDataOther"
                :before-upload="beforeUploadOther" :on-success="successUploadOther" :on-error="errorUploadOther"
                :accept="'image/*'"
                :on-remove="handleRemoveOther"
                :before-remove="beforeRemoveOther"
                multiple
                :limit="3"
                :on-exceed="handleExceedOther"
                :on-change="handleUploadChangeOther"
                :file-list="otherFileList">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <el-row style="text-align:center;margin: 20px auto">
            <el-button style="width: 25%" type="success" @click="back()">上一步</el-button>
            <el-button style="width: 25%" type="success" @click="nextLoanInfo()">贷款资料备案上报</el-button>
          </el-row>
        </el-row>
      </el-row>
      <!-- 贷款备案进度 -->
      <el-row v-show="speedVisible" class="back-up" style="background-color: #fff;text-align:center;">
        <el-row style="margin-top:30px;" v-show="addVisible">
          <el-row style="margin-top:10px;font-size:14px">
            <span>状态：提交成功。</span><br>
            <span>贷款资料备案上报成功，请等待审核结果。</span>
          </el-row>
          <el-row style="margin: 20px auto"><el-button style="width: 50%" type="success" @click="home()">回首页</el-button></el-row>
        </el-row>
        <el-row style="margin-top:30px;" v-show="successVisible">
          <el-row style="margin-top:10px;font-size:14px">
            <span>状态：审核通过。</span><br>
            <span>恭喜你 {{ dataDt }} 号上报的贷款资料信息已经通过审核，生源地贷款可抵用学费和住宿费 {{ amount }} 元。</span>
          </el-row>
          <el-row style="margin: 20px auto"><el-button style="width: 50%" type="success" @click="nextPayFee()">下一步</el-button></el-row>
        </el-row>
        <el-row style="margin-top:30px;" v-show="errorVisible">
          <el-row style="margin-top:10px;font-size:14px">
            <span>状态：审核退回。</span><br>
            <span>您可选择修改资料重新上报，或者放弃上报进入缴费流程。</span><br>
            <span>原因：{{ memo }}</span>
          </el-row>
          <el-row style="margin: 20px auto">
            <el-button style="width: 25%" type="success" @click="update()">修改资料</el-button>
            <el-button style="width: 25%" type="success" @click="nextPayFee()">放弃上报</el-button>
          </el-row>
        </el-row>
      </el-row>
      <!-- 关注微信 -->
      <el-row>
        <el-dialog title="微信二维码" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
          <el-row style="text-align:center;padding:10px 0">
            <img :src="weixin" />
          </el-row>
        </el-dialog>
      </el-row>
    </el-row>
  </el-row>
</template>
<script>
import { getToken, getExpires } from '@/assets/js/auth'
export default {
  name: 'LoanXiFan', // ?
  data: function () {
    // 特殊的校验
    var checkAmount = (rule, value, callback) => {
      if (value) {
        if (!this.Ginkgo.isMoney(value)) {
          return callback(new Error('请输入正确的金额！'))
        } else if (value === '0') {
          return callback(new Error('请输入大于0金额！'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    var checkMobile = (rule, value, callback) => {
      if (value) {
        if (!this.Ginkgo.isMobile(value)) {
          return callback(new Error('请输入正确的手机号！'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      profile: 'prod',
      modeSelectList: [],
      loanForm: {
        dataDt: 0,
        schoolYear: 0,
        studentName: '',
        keyInfo: '',
        mobile: '',
        bankType: '01',
        loanAmount: '',
        loanUrl: '',
        uidJustUrl: '',
        uidBackUrl: '',
        otherUrl: '',
        studentType: '01',
        statusCode: '01'
      }, // 贷款对象
      // 控制属性
      loanInfoVisible: false,
      chooseVisible: false,
      speedVisible: false,
      addVisible: false,
      successVisible: false,
      errorVisible: false,
      formLabelWidth: '155px',

      uiSetItemList: [], // 原始
      uiSetList: [],

      // 贷款
      radio: '0',
      loanFileList: [],
      uidJustFileList: [],
      uidBackFileList: [],
      otherFileList: [],
      fileList: [],
      bankTypeList: [],
      loanInfoList: [], // 贷款查询结果
      dataDt: '2020-01-01',
      amount: 0,
      memo: '上传信息不符合。',
      dialogFormVisible: false,

      financeOffice: {},
      apartmentOffice: {},
      deanOffice: {},
      admissionsOffice: {},
      technicalSupport: {},
      informationManagementCenter: {},
      customerService: {},

      // 上传文件相关参数
      uploadAction: 'static/uploadFile',
      uploadHead: {},
      uploadData: {},
      uploadDataOther: {},
      uploadFileNameLoan: '', // 当前上传的文件名（不带扩展名）
      uploadFileNameFullLoan: '', // 当前上传的文件名（带扩展名）
      uploadFileNameUidJust: '', // 当前上传的文件名（不带扩展名）
      uploadFileNameFullUidJust: '', // 当前上传的文件名（带扩展名）
      uploadFileNameUidBack: '', // 当前上传的文件名（不带扩展名）
      uploadFileNameFullUidBack: '', // 当前上传的文件名（带扩展名）
      uploadFileNameOther: '', // 当前上传的文件名（不带扩展名）
      uploadFileNameFullOther: '', // 当前上传的文件名（带扩展名）
      targetPath: '/', // 目标路径，UUID

      // ！！！校验规则（注意去掉最后一个属性的“,”号）
      rules: {
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        loanAmount: [
          { required: true, message: '请输入贷款金额', trigger: 'blur' },
          { validator: checkAmount, trigger: 'blur' }
        ]
      },
      weixin: this.global.staticResourceAddr + 'gsvvuepc/zft2Code.jpg',
      // 队列
      pageItems: [],
      maxSize: 10
    }
  },
  mounted: function () {
    var self = this
    if (process.env.NODE_ENV === 'production') {
      self.getMode()
      self.resetForm()
      self.getLoanInfoItem()
      self.getPhoneMode()
    } else {
      self.global.modeList = [
        {typeId: 'XF_Bank_Type', modeId: '01', modeName: '国开行', modeValue: '', parentModeId: '', seqNo: '', rank: 1, field1: ''},
        {typeId: 'XF_Bank_Type', modeId: '02', modeName: '其他行', modeValue: '', parentModeId: '', seqNo: '', rank: 2, field1: ''}
      ]
      self.getMode()
      self.resetForm()
      self.setVisible('01')
      self.getPhoneMode()
    }
  },
  watch: {
    tabSelected: 'handleSelect'
  },
  methods: {
    setVisible: function (showType) {
      this.addPage(showType)
      if (showType === '01') { // 贷款显示
        this.chooseVisible = true
        this.loanInfoVisible = false
        this.speedVisible = false
        this.addVisible = false
        this.successVisible = false
        this.errorVisible = false
      }
      if (showType === '02') { // 贷款信息
        this.chooseVisible = false
        this.loanInfoVisible = true
        this.speedVisible = false
        this.addVisible = false
        this.successVisible = false
        this.errorVisible = false
      }
      if (showType === '03') { // 贷款进度(提交)
        this.chooseVisible = false
        this.loanInfoVisible = false
        this.speedVisible = true
        this.addVisible = true
        this.successVisible = false
        this.errorVisible = false
      }
      if (showType === '04') { // 贷款进度(通过)
        this.chooseVisible = false
        this.loanInfoVisible = false
        this.speedVisible = true
        this.addVisible = false
        this.successVisible = true
        this.errorVisible = false
      }
      if (showType === '05') { // 贷款进度(驳回)
        this.chooseVisible = false
        this.loanInfoVisible = false
        this.speedVisible = true
        this.addVisible = false
        this.successVisible = false
        this.errorVisible = true
      }
    },
    getPhoneMode: function () {
      this.global.phoneModeList.filter(item => {
        switch (item.modeId) {
          case '00': this.financeOffice = item
            break
          case '01': this.apartmentOffice = item
            break
          case '02': this.deanOffice = item
            break
          case '03': this.admissionsOffice = item
            break
          case '04': this.technicalSupport = item
            break
          case '05': this.informationManagementCenter = item
            break
          case '06': this.customerService = item
            break
        }
      })
    },
    back: function () {
      this.setVisible(this.pageItems[this.pageItems.length - 2])
    },
    // 返回结果处理
    getStatusValue: function () {
      let loanInfo = this.loanInfoList[0]
      switch (loanInfo.statusCode) {
        case '00': // 通过
          this.dataDt = this.Ginkgo.getToday(this.Ginkgo.intToDate(loanInfo.dataDt))
          this.amount = loanInfo.loanAmount
          this.setVisible('04')
          break
        case '01': // 新增
          this.setVisible('01')
          break
        case '02': // 提交
          this.setVisible('03')
          break
        case '03': // 驳回
          this.memo = loanInfo.memo
          this.setVisible('05')
          break
        default:
          this.setVisible('01')
          break
      }
    },
    // 获取贷款信息
    getLoanInfoItem: function () {
      var self = this
      if (process.env.NODE_ENV === 'production') {
        this.axios.post('/college/getXFLoanInfo', {
          schoolYear: self.global.curUser.schoolYear,
          keyInfo: self.global.curStudent.uid
        })
        .then(function (response) {
          if (response.data.result.success === true) {
            self.loanInfoList = response.data.loanInfoList
            if (response.data.loanInfoList.length > 0) { // 有记录看结果
              self.getStatusValue()
            } else {
              self.setVisible('01')
            }
          } else {
            self.$alert('系统错误！')
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    // 下一步 新增
    nextLoan: function () {
      if (this.radio === '1') {
        if (this.loanInfoList.length > 0) {
          this.update()
        } else {
          this.loanForm.schoolYear = this.global.curUser.schoolYear
          this.loanForm.keyInfo = this.global.curStudent.uid
          this.loanForm.studentName = this.global.curStudent.studentName
          this.setVisible('02')
        }
      } else {
        this.nextPayFee()
      }
    },
    // 下一步
    nextLoanInfo: function () {
      var self = this
      if (process.env.NODE_ENV === 'production') {
        self.$refs.loanForm.validate((valid) => {
          if (valid) {
            if (!this.checkLoanMoney()) {
              self.$alert('贷款金额不能超过' + this.modeSelector('Loan_Max_Set')[0].modeValue + '元！')
              return false
            }
            let list = self.checkPhoto()
            if (list.flay) {
              // 处理补充图片
              self.loanForm.otherUrl = ''
              self.fileList.forEach(function (element) {
                if (self.loanForm.otherUrl === '') {
                  self.loanForm.otherUrl = element.url
                } else {
                  self.loanForm.otherUrl = self.loanForm.otherUrl + ';' + element.url
                }
              })
              self.loanForm.dataDt = self.Ginkgo.dateToInt(self.Ginkgo.getDefaultDate())
              self.loanForm.statusCode = '02'
              console.log('loanForm', self.loanForm)
              this.axios.post('/college/addXFLoanInfo', self.loanForm)
              .then(function (response) {
                if (response.data.result.success === true) {
                  self.$alert('新增贷款信息成功！')
                  self.setVisible('03')
                } else {
                  self.$alert('新增贷款信息失败！')
                  self.setVisible('02')
                }
              }, response => {
              })
              .catch(function (error) {
                console.log(error)
              })
            } else {
              self.$alert(list.msg)
              self.setVisible('02')
            }
          }
        })
      } else {
        self.$refs.loanForm.validate((valid) => {
          if (valid) {
            // 处理补充图片
            self.loanForm.otherUrl = ''
            self.fileList.forEach(function (element) {
              if (self.loanForm.otherUrl === '') {
                self.loanForm.otherUrl = element.url
              } else {
                self.loanForm.otherUrl = self.loanForm.otherUrl + ';' + element.url
              }
            })
            self.loanForm.dataDt = self.Ginkgo.dateToInt(self.Ginkgo.getDefaultDate())
            self.loanForm.statusCode = '02'
            self.setVisible('03')
          }
        })
      }
    },
    // 检查贷款金额
    checkLoanMoney: function () {
      let loanSetList = this.modeSelector('Loan_Max_Set')
      if (loanSetList.length !== 1) {
        this.$alert('贷款上限设置异常，请联系管理员！')
        return false
      } else {
        let loanSet = loanSetList[0]
        if ((Number(loanSet.modeValue) * 100) >= (Number(this.loanForm.loanAmount) * 100)) {
          return true
        } else {
          return false
        }
      }
    },
    // 检查图片上传
    checkPhoto: function () {
      let list = {}
      list.flay = true
      list.msg = ''
      if (this.loanForm.loanUrl === '') {
        list.flay = false
        list.msg = '请上传贷款受理证明或回执单！'
      }
      if (this.loanForm.uidJustUrl === '' || this.loanForm.uidBackUrl === '') {
        list.flay = false
        list.msg = '请上传身份证正反面！'
      }
      return list
    },
    update: function () {
      var self = this
      self.loanFileList = []
      self.uidJustFileList = []
      self.uidBackFileList = []
      self.otherFileList = []
      self.fileList = []

      self.setVisible('02')
      self.loanForm = self.loanInfoList[0]
      // 图片特殊处理
      let fileRow = {}
      let nameList = self.loanForm.loanUrl.split('/')
      fileRow.name = (nameList.slice(nameList.length - 1, nameList.length))[0]
      fileRow.url = self.global.staticUploadAddr + self.loanForm.loanUrl
      self.loanFileList.push(fileRow)
      // 身份证国徽面
      fileRow = {}
      nameList = self.loanForm.uidJustUrl.split('/')
      fileRow.name = (nameList.slice(nameList.length - 1, nameList.length))[0]
      fileRow.url = self.global.staticUploadAddr + self.loanForm.uidJustUrl
      self.uidJustFileList.push(fileRow)
      // 身份证人像面
      fileRow = {}
      nameList = self.loanForm.uidBackUrl.split('/')
      fileRow.name = (nameList.slice(nameList.length - 1, nameList.length))[0]
      fileRow.url = self.global.staticUploadAddr + self.loanForm.uidBackUrl
      self.uidBackFileList.push(fileRow)
      // 补充材料
      let otherFileRow = {}
      if (self.loanForm.otherUrl !== '') {
        let otherList = self.loanForm.otherUrl.split(';')
        otherList.forEach(function (element) {
          fileRow = {}
          nameList = element.split('/')
          fileRow.name = (nameList.slice(nameList.length - 1, nameList.length))[0]
          fileRow.url = self.global.staticUploadAddr + element
          console.log('fileRow', fileRow)
          self.otherFileList.push(fileRow)
          // 保存用
          otherFileRow = {}
          otherFileRow.name = (nameList.slice(nameList.length - 1, nameList.length))[0]
          otherFileRow.url = element
          console.log('otherFileRow', otherFileRow)
          self.fileList.push(otherFileRow)
        })
      }
    },
    home: function () { // 登录页面
      this.global.isLoan = '0'
      this.$router.push('/LoginXiFan')
      this.route = [{ path: '/LoginXiFan', component: require('./LoginXiFan.vue'), meta: { title: '登录页面' } }]
      this.$router.addRoutes(this.route)
    },
    nextPayFee: function () { // 新生缴费
      this.global.isLoan = '1'
      if (this.global.curStudent.trainingLevel === '专升本') {
        this.$router.push('/MyBillXiFanZSB')
        this.route = [{ path: '/MyBillXiFanZSB', component: require('./MyBillXiFanZSB.vue'), meta: { title: '新生缴费' } }]
        this.$router.addRoutes(this.route)
      } else {
        this.$router.push('/MyBillXiFanNew')
        this.route = [{ path: '/MyBillXiFanNew', component: require('./MyBillXiFanNew.vue'), meta: { title: '新生缴费' } }]
        this.$router.addRoutes(this.route)
      }
    },
    // 初始化数据字典
    getMode: function () {
      var self = this
      self.modeSelectList = self.global.modeList
      self.bankTypeList = self.global.modeList.filter(function (element) {
        return element.typeId === 'XF_Bank_Type'
      })
    },
    // 重置编辑窗体
    resetForm: function () {
      this.loanForm = {
        dataDt: 0,
        schoolYear: 0,
        studentName: '',
        keyInfo: '',
        mobile: '',
        bankType: '01',
        loanAmount: '',
        remark: '',
        loanUrl: '',
        uidJustUrl: '',
        uidBackUrl: '',
        otherUrl: '',
        studentType: '01',
        statusCode: '01'
      }
      // 本次流程上传的路径
      this.targetPath = '/images/gsvxifanvuem/loan/' + this.global.curUser.schoolYear + '_' + this.global.curStudent.uid
    },
    // 数据字典筛选器
    modeSelector: function (typeId) {
      let list = []
      list = this.modeSelectList.filter(function (element) {
        return element.typeId === typeId
      })
      return list
    },
    showWechatImg: function () {
      this.dialogFormVisible = true
    },
    handleSelect: function (index, indexPath) {
      if (process.env.NODE_ENV === 'production') {
        if (index === '/MyLoan') {
          this.getLoanInfoItem()
        }
        if (index === '/OfflinePay') {
          // 跳转到线下缴费页面
          this.$router.push('/offlinePay')
          this.route = [{ path: '/offlinePay', component: () => import('@/components/XiFan/NewStudent/OfflinePay.vue'), meta: { title: '线下审核' } }]
          this.$router.addRoutes(this.route)
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan')
          this.route = [{ path: '/LoginXiFan', component: require('./LoginXiFan.vue'), meta: { title: '缴费登录' } }]
          this.$router.addRoutes(this.route)
        }
      } else {
        if (index === '/MyLoan') {
          this.getLoanInfoItem()
        }
        if (index === '/OfflinePay') {
          // 跳转到线下缴费页面
          this.$router.push('/offlinePay')
          this.route = [{ path: '/offlinePay', component: () => import('@/components/XiFan/NewStudent/OfflinePay.vue'), meta: { title: '线下审核' } }]
          this.$router.addRoutes(this.route)
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan')
          this.route = [{ path: '/LoginXiFan', component: require('./LoginXiFan.vue'), meta: { title: '缴费登录' } }]
          this.$router.addRoutes(this.route)
        }
      }
    },
    // --------------------------------------------------------贷款证明文件上传------------------------------------------------------
    // 上传文件事件方法
    handleUploadChangeLoan: function (file, fileList) {
      console.log(file, fileList)
      if (fileList.length > 0) {
        this.loanFileList = fileList.filter(item => item.name === file.name)
        this.uploadFileNameFullLoan = file.name
        let s = file.name.split('.')
        // 文件名去掉扩展名
        if (s.length - 1 === 0) { // 没有扩展名
          this.uploadFileNameLoan = file.name
        } else {
          this.uploadFileNameLoan = file.name.substr(0, file.name.length - s[s.length - 1].length - 1)
        }
      }
    },
    // 上传文件前事件方法
    beforeUploadLoan: function (file) {
      // 将cookie中的token取至head。
      let tokenBuffer = document.cookie.substring(document.cookie.indexOf('XSRF-TOKEN' + '='))
      this.uploadHead['X-XSRF-TOKEN'] = tokenBuffer.substring(tokenBuffer.indexOf('=') + 1, tokenBuffer.indexOf(';') > 0 ? tokenBuffer.indexOf(';') : tokenBuffer.length)
      this.uploadHead['Authorization'] = `Bearer ` + getToken()
      this.uploadHead['Expires'] = getExpires()
      // 补充上传参数。
      this.uploadData.fileName = this.uploadFileNameLoan
      this.uploadData.fileDesc = ''
      this.uploadData.targetPath = this.targetPath
      this.uploadData.isRandomName = false
      this.uploadData.isOverwrite = true
      this.uploadData.flag = '01'
    },
    // 上传成功后回调
    successUploadLoan: function (response, file, fileList) {
      this.loanForm.loanUrl = ''
      if (response.result.success) {
        this.$message({ type: 'success', message: '上传成功!' })
        let fileName = this.uploadFileNameLoan
        let fileAddress = response.uploadData.url
        console.log('file：', fileName, fileAddress)
        this.loanForm.loanUrl = fileAddress
      } else {
        this.$alert(response.result.msg)
      }
    },
    errorUploadLoan: function (err, file, fileList) {
      console.log(err)
    },
    // 上传文件
    submitUploadLoan() {
      this.$refs.upload.submit()
    },
    handleRemoveLoan: function (file, fileList) {
      this.loanForm.loanUrl = ''
      console.log('handleRemoveLoan', file, fileList)
    },
    handleExceedLoan: function (files, fileList) {
      this.$message.warning('当前限制选择 1 个文件')
    },
    beforeRemoveLoan(file, fileList) {
      console.log('beforeRemoveLoan', file, fileList)
      return this.$confirm('确定移除')
    },
    // --------------------------------------------------------身份证国徽面上传------------------------------------------------------
    // 上传文件事件方法
    handleUploadChangeUidJust: function (file, fileList) {
      console.log(file, fileList)
      if (fileList.length > 0) {
        this.uidJustFileList = fileList.filter(item => item.name === file.name)
        this.uploadFileNameFullUidJust = file.name
        let s = file.name.split('.')
        // 文件名去掉扩展名
        if (s.length - 1 === 0) { // 没有扩展名
          this.uploadFileNameUidJust = file.name
        } else {
          this.uploadFileNameUidJust = file.name.substr(0, file.name.length - s[s.length - 1].length - 1)
        }
      }
    },
    // 上传文件前事件方法
    beforeUploadUidJust: function (file) {
      // 将cookie中的token取至head。
      let tokenBuffer = document.cookie.substring(document.cookie.indexOf('XSRF-TOKEN' + '='))
      this.uploadHead['X-XSRF-TOKEN'] = tokenBuffer.substring(tokenBuffer.indexOf('=') + 1, tokenBuffer.indexOf(';') > 0 ? tokenBuffer.indexOf(';') : tokenBuffer.length)
      this.uploadHead['Authorization'] = `Bearer ` + getToken()
      this.uploadHead['Expires'] = getExpires()
      // 补充上传参数。
      this.uploadData.fileName = this.uploadFileNameUidJust
      this.uploadData.fileDesc = ''
      this.uploadData.targetPath = this.targetPath
      this.uploadData.isRandomName = false
      this.uploadData.isOverwrite = true
      this.uploadData.flag = '01'
    },
    // 上传成功后回调
    successUploadUidJust: function (response, file, fileList) {
      this.loanForm.uidJustUrl = ''
      if (response.result.success) {
        this.$message({ type: 'success', message: '上传成功!' })
        let fileName = this.uploadFileNameUidJust
        let fileAddress = response.uploadData.url
        console.log('file：', fileName, fileAddress)
        this.loanForm.uidJustUrl = fileAddress
      } else {
        this.$alert(response.result.msg)
      }
    },
    errorUploadUidJust: function (err, file, fileList) {
      console.log(err)
    },
    // 上传文件
    submitUploadUidJust() {
      this.$refs.upload.submit()
    },
    handleRemoveUidJust: function (file, fileList) {
      this.loanForm.uidJustUrl = ''
      console.log('handleRemoveUidJust', file, fileList)
    },
    handleExceedUidJust: function (files, fileList) {
      this.$message.warning('当前限制选择 1 个文件')
    },
    beforeRemoveUidJust(file, fileList) {
      console.log('beforeRemoveUidJust', file, fileList)
      return this.$confirm('确定移除')
    },
    // --------------------------------------------------------身份证人像面上传------------------------------------------------------
    // 上传文件事件方法
    handleUploadChangeUidBack: function (file, fileList) {
      console.log(file, fileList)
      if (fileList.length > 0) {
        this.uidBackFileList = fileList.filter(item => item.name === file.name)
        this.uploadFileNameFullUidBack = file.name
        let s = file.name.split('.')
        // 文件名去掉扩展名
        if (s.length - 1 === 0) { // 没有扩展名
          this.uploadFileNameUidBack = file.name
        } else {
          this.uploadFileNameUidBack = file.name.substr(0, file.name.length - s[s.length - 1].length - 1)
        }
      }
    },
    // 上传文件前事件方法
    beforeUploadUidBack: function (file) {
      // 将cookie中的token取至head。
      let tokenBuffer = document.cookie.substring(document.cookie.indexOf('XSRF-TOKEN' + '='))
      this.uploadHead['X-XSRF-TOKEN'] = tokenBuffer.substring(tokenBuffer.indexOf('=') + 1, tokenBuffer.indexOf(';') > 0 ? tokenBuffer.indexOf(';') : tokenBuffer.length)
      this.uploadHead['Authorization'] = `Bearer ` + getToken()
      this.uploadHead['Expires'] = getExpires()
      // 补充上传参数。
      this.uploadData.fileName = this.uploadFileNameUidBack
      this.uploadData.fileDesc = ''
      this.uploadData.targetPath = this.targetPath
      this.uploadData.isRandomName = false
      this.uploadData.isOverwrite = true
      this.uploadData.flag = '01'
    },
    // 上传成功后回调
    successUploadUidBack: function (response, file, fileList) {
      this.loanForm.uidBackUrl = ''
      if (response.result.success) {
        this.$message({ type: 'success', message: '上传成功!' })
        let fileName = this.uploadFileNameUidBack
        let fileAddress = response.uploadData.url
        console.log('file：', fileName, fileAddress)
        this.loanForm.uidBackUrl = fileAddress
      } else {
        this.$alert(response.result.msg)
      }
    },
    errorUploadUidBack: function (err, file, fileList) {
      console.log(err)
    },
    // 上传文件
    submitUploadUidBack() {
      this.$refs.upload.submit()
    },
    handleRemoveUidBack: function (file, fileList) {
      this.loanForm.uidBackUrl = ''
      console.log('handleRemoveUidBack', file, fileList)
    },
    handleExceedUidBack: function (files, fileList) {
      this.$message.warning('当前限制选择 1 个文件')
    },
    beforeRemoveUidBack(file, fileList) {
      console.log('beforeRemoveUidBack', file, fileList)
      return this.$confirm('确定移除')
    },
    // --------------------------------------------------------其他证明文件上传------------------------------------------------------
    // 上传文件事件方法
    handleUploadChangeOther: function (file, fileList) {
      if (fileList.length > 0) {
        // this.fileList = fileList.filter(item => item.name === file.name)
        this.uploadFileNameFullOther = file.name
        let s = file.name.split('.')
        // 文件名去掉扩展名
        if (s.length - 1 === 0) { // 没有扩展名
          this.uploadFileNameOther = file.name
        } else {
          this.uploadFileNameOther = file.name.substr(0, file.name.length - s[s.length - 1].length - 1)
        }
      }
    },
    // 上传文件前事件方法
    beforeUploadOther: function (file) {
      // 将cookie中的token取至head。
      let tokenBuffer = document.cookie.substring(document.cookie.indexOf('XSRF-TOKEN' + '='))
      this.uploadHead['X-XSRF-TOKEN'] = tokenBuffer.substring(tokenBuffer.indexOf('=') + 1, tokenBuffer.indexOf(';') > 0 ? tokenBuffer.indexOf(';') : tokenBuffer.length)
      this.uploadHead['Authorization'] = `Bearer ` + getToken()
      this.uploadHead['Expires'] = getExpires()
      // 补充上传参数。
      this.uploadDataOther.fileName = this.uploadFileNameOther
      this.uploadDataOther.fileDesc = ''
      this.uploadDataOther.targetPath = this.targetPath
      this.uploadDataOther.isRandomName = false
      this.uploadDataOther.isOverwrite = true
      this.uploadDataOther.flag = '01'
    },
    // 上传成功后回调
    successUploadOther: function (response, file, fileList) {
      var self = this
      if (response.result.success) {
        this.$message({ type: 'success', message: '上传成功!' })
        let fileRow = {}
        fileRow.name = this.uploadFileNameFullOther
        fileRow.url = response.uploadData.url
        self.fileList.push(fileRow)
      } else {
        this.$alert(response.result.msg)
      }
    },
    errorUploadOther: function (err, file, fileList) {
      console.log('errorUploadOther', err)
    },
    // 上传文件
    submitUploadOther() {
      this.$refs.upload.submit()
    },
    handleRemoveOther: function (file, fileList) {
      console.log('handleRemoveOther', file, fileList)
      this.fileList = this.fileList.filter(item => item.name !== file.name)
    },
    handleExceedOther: function (files, fileList) {
      this.$message.warning('当前限制选择 3 个文件')
    },
    beforeRemoveOther(file, fileList) {
      return this.$confirm('确定移除')
    },
    addPage(val) {
      if (!val) return
      if (this.pageItems.length >= this.maxSize) {
        this.pageItems.shift()
      }
      this.pageItems.push(val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// LoanXiFanNew.vue?5f2746a9